import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=eedfd256&scoped=true&"
import script from "./basic.vue?vue&type=script&setup=true&lang=js&"
export * from "./basic.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./basic.vue?vue&type=style&index=0&id=eedfd256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedfd256",
  null
  
)

export default component.exports